<template scoped>
  <b-modal
    v-model="trigger"
    :id="id"
    :ok-title="okTitle"
    :title="title"
    @ok="eventOk($event)"
    @cancel="eventCancel($event)"
    :centered="centered"
    :no-close-on-backdrop="dontCloseWhenClickedOutside"
    :no-close-on-esc="dontCloseWhenEscapePressed"
    :hide-header-close="dontShowCloseIcon"
    :ok-only="okOnly"
    :header-bg-variant="headerBgVariant"
    :hide-footer="true"
    :hide-header="true"
  >
    <div>
      <p class="pt-3 Confirmation-text">Confirmation</p>
      <p class="p-0 m-0 p-3 resposne-text">{{text}}</p>
      <hr class="mx-5" />
      <div class="text-center mb-2">
        <b-button @click="ConformationApprovalYes($event)" class="confirmation-button mr-3">Yes</b-button>
        <b-button @click="ConformationApprovalNo($event)" class="confirmation-cancel">No</b-button>
      </div>
    </div>
  </b-modal>
</template>
<script>
export default {
  props: [
    "trigger",
    "text",
    "okTitle",
    "okOnly",
    "id",
    "title",
    "centered",
    "dontCloseWhenClickedOutside",
    "dontCloseWhenEscapePressed",
    "dontShowCloseIcon"
  ],
  data() {
    return {
      show: false,
      headerBgVariant: "bg-headerModule",
      headerTextVariant: "light",
      footerBgVariant: "warning",
      footerTextVariant: "dark"
    };
  },
  methods: {
    ConformationApprovalYes(event) {
      this.$emit("eventOk", event);
    },
    ConformationApprovalNo(event) {
      this.$emit("eventCancel", event);
    }
  }
};
</script>

<style scoped>
.Confirmation-text {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
}
.resposne-text {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  text-align: center !important;
}
.confirmation-button {
  width: 69px;
  height: 30px;
  border-radius: 4px;
  background-color: #1579ab;
  font-family: "Source Sans Pro", sans-serif;
}
.confirmation-cancel {
  width: 69px;
  height: 30px;
  border-radius: 4px;
  border: solid 1px #446f8b;
  background-color: #ffffff;
  background: none;
  color: #333333;
}
</style>